import { membershipTiers } from '@/mocks/yihao';

export default function MembershipSection() {
  return (
    <section className="w-full px-6 md:px-10 py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">会员权益</h2>
          <p className="text-foreground-600 text-base max-w-2xl mx-auto">
            加入壹号娱乐VIP会员，尊享专属特权与奢华礼遇。等级越高，权益越丰厚。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {membershipTiers.map((tier, idx) => (
            <div
              key={tier.name}
              className={`relative rounded-xl p-6 md:p-8 border ${tier.border} ${tier.bg} transition-transform duration-300 hover:-translate-y-1 cursor-pointer`}
            >
              {idx === 2 && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-4 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-bold whitespace-nowrap">
                  最受欢迎
                </div>
              )}
              <div className="flex items-center gap-3 mb-5">
                <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${tier.bg} border ${tier.border}`}>
                  <i className={`${tier.icon} ${tier.color} text-2xl`}></i>
                </div>
                <div>
                  <h3 className={`font-heading font-bold text-xl ${tier.color}`}>{tier.name}</h3>
                  <p className="text-foreground-500 text-xs mt-0.5">{tier.threshold}</p>
                </div>
              </div>
              <ul className="space-y-3 mb-6">
                {tier.benefits.map((benefit, i) => (
                  <li key={i} className="flex items-start gap-3 text-sm text-foreground-700">
                    <i className="ri-check-fill text-primary-500 mt-0.5 flex-shrink-0"></i>
                    <span>{benefit}</span>
                  </li>
                ))}
              </ul>
              <button className="w-full py-2.5 rounded-lg border-2 border-primary-500 text-primary-600 font-medium text-sm whitespace-nowrap hover:bg-primary-500 hover:text-white transition-all duration-200 cursor-pointer">
                了解详情
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}